import Vue from 'vue'
import VueSlideoutPanel from 'vue2-slideout-panel'

Vue.use(VueSlideoutPanel)
